module["exports"] = [
  "s Väg",
  "s Gata"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/common_street_suffix.js
// module id = 2721
// module chunks = 2